import * as types from '../actionTypes';
import { notifications } from './initialState';

const notificationReducer = (state = notifications, action) => {
  switch (action.type) {
    case types.GET_NOTIFICATION:
      return action.payload;
    default:
      return state;
  }
};

export default notificationReducer;
